// extracted by mini-css-extract-plugin
export default {"grid":"DropdownCommon__grid___Ae5vM","featured":"DropdownCommon__featured___mjIUd","features":"DropdownCommon__features___EFSHB","header":"DropdownCommon__header___AlxMS"};